// ---------------------------------------------------------------------------
// BLOG CONTENT LOADER
// ---------------------------------------------------------------------------
// Posts live in posts.json (edited by hand and by the automated blog bot in
// scripts/blog-bot). This module just loads that data and exposes helpers.
// To add or edit a post, change posts.json — not this file.
//
// Post fields:
//   slug      unique url segment -> /blog/<slug>
//   title, category, excerpt, author
//   date      ISO 'YYYY-MM-DD' (rendered "Jun 18, 2026")
//   updatedAt optional ISO date for a substantive editorial revision; does not reorder posts
//   readTime  integer minutes
//   accent    hex color for the cover / pill
//   image     path to a cover image (e.g. "/img/blog/<slug>.png") or null
//             (null falls back to the branded gradient cover)
//   body      array of blocks: {type:'p'|'h2'|'quote'|'code', text}
//             or {type:'ul', items:[...]}
//             or {type:'link', text, href} (local path or HTTPS; plain text, no HTML)
// ---------------------------------------------------------------------------

import postsData from './publishedPosts';

export const blogPosts = postsData;

const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

export const formatDate = (iso) => {
  const d = new Date(`${iso}T00:00:00`);
  if (Number.isNaN(d.getTime())) return iso;
  return `${MONTHS[d.getMonth()]} ${d.getDate()}, ${d.getFullYear()}`;
};

export const getPostBySlug = (slug) => blogPosts.find((p) => p.slug === slug);

// Newest first.
export const sortedPosts = () =>
  [...blogPosts].sort((a, b) => new Date(b.date) - new Date(a.date));
